import { VueModule } from '@Foundation';
import BeforeAfterSlider from './code/Scripts/components/before-after-slider';

export default VueModule({
  components: {
    BeforeAfterSlider
  }
});
